import React, { useEffect, useState } from 'react';

const LoadingScreen = ({ duckImage }) => {
  const [progress, setProgress] = useState(0);
  const [loadingText, setLoadingText] = useState('');

  const loadingMessages = ["eepy..."];

  useEffect(() => {
    const progressInterval = setInterval(() => {
      setProgress(prev => {
        if (prev >= 100) return 100;
        return prev + Math.random() * 15 + 5;
      });
    }, 200);

    const textInterval = setInterval(() => {
      setLoadingText(loadingMessages[Math.floor(Math.random() * loadingMessages.length)]);
    }, 800);

    return () => {
      clearInterval(progressInterval);
      clearInterval(textInterval);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const stars = Array.from({ length: 40 }, (_, i) => ({
    id: i,
    size: Math.random() * 3 + 1,
    left: Math.random() * 100,
    top: Math.random() * 100,
    delay: Math.random() * 3,
    duration: Math.random() * 2 + 1
  }));

  return (
    <div className="fixed inset-0 bg-cute-dark flex flex-col items-center justify-center z-50 overflow-hidden">
      {/* Stars */}
      {stars.map((star) => (
        <div
          key={star.id}
          className="absolute rounded-full bg-white"
          style={{
            width: `${star.size}px`,
            height: `${star.size}px`,
            left: `${star.left}%`,
            top: `${star.top}%`,
            animation: `twinkle ${star.duration}s ease-in-out infinite`,
            animationDelay: `${star.delay}s`,
            opacity: 0.3
          }}
        />
      ))}

      {/* Main Content */}
      <div className="relative z-10 flex flex-col items-center">
        <h1 className="mt-8 text-4xl md:text-5xl font-display text-white tracking-wider">
          Esther
        </h1>

        <p className="mt-4 text-white/40 text-base font-mono h-6">
          {loadingText}
        </p>

        <div className="mt-6 w-64 md:w-80">
          <div className="progress-bar">
            <div
              className="progress-fill"
              style={{ width: `${Math.min(progress, 100)}%` }}
            />
          </div>
        </div>
      </div>

      <style jsx>{`
        @keyframes twinkle {
          0%, 100% { opacity: 0.1; transform: scale(0.8); }
          50% { opacity: 0.4; transform: scale(1); }
        }
      `}</style>
    </div>
  );
};

export default LoadingScreen;
